import { useEffect, useRef } from 'react';

// Runs `callback` after `delay` ms of quiet on `dependencies` (the timer resets on each change).
// Mirrors the BW facilitator-dropdown debounce used for server-searched selects.
export function useDebounce(callback: () => void, delay: number, dependencies: unknown[]): void {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      callbackRef.current();
    }, delay);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [...dependencies, delay]);
}
